import React from "react";
import loginLogo from "../../assets/images/login-signup/loginLogo.png";
import loginImg from "../../assets/images/login-signup/login.png";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import { object, string } from "yup";
import { axiosInstance } from "../../axiosInstance";

const ForgotSchema = object({
  email: string()
    .email("Invalid email address (must include '@')")
    .required("Email is required"),
});

export function Forgot() {
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      email: "",
      userType: "USER",
    },
    validationSchema: ForgotSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        const formattedValues = {
          ...values,
        };

        const { data } = await axiosInstance.post(
          "/forgotPassword",
          formattedValues
        );

        if (data.status === 200) {
          toast.success(data.message || "Mail Sent Successfully!");
          resetForm();
          localStorage.setItem("email", values.email);
          setTimeout(() => {
            navigate("/otp");
          }, 3000);
        } else {
          toast.error("Something went wrong, please try again!");
        }
      } catch (error) {
        console.error("Submission failed:", error);
        toast.error("Submission failed! Please try again.");
      }
    },
  });
  return (
    <>
      <ToastContainer />
      <div className="login-container container">
        <div className="login-subcontainer">
          <form onSubmit={formik.handleSubmit}>
            <div className="login-left">
              <div className="login-logo">
                <img src={loginLogo} />
              </div>

              <div className="loginForm-container">
                <div className="login-title">Forgot Password</div>
                <div className="login-field">
                  <label for="email">Email Address</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter your email address"
                      id="email"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                    />
                  </div>
                  {formik.touched.email && formik.errors.email && (
                    <div className="formError">{formik.errors.email}</div>
                  )}
                </div>

                <div className="btnLogin">
                  <button>Submit</button>
                </div>
                <div className="btnCreate">
                  <Link to="/login">
                    {" "}
                    <button>Back</button>
                  </Link>
                </div>
              </div>
            </div>
          </form>
          <div className="login-right">
            <div>
              <img src={loginImg} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
